<template>
  <div style="background-color: #0f0f0f;">
    <slot />
  </div>
</template>